import { getToken } from '@/utils/token'

/*
 *
 * ali-oss查找原因需要提供requestId
 *
 * Q:
 * 使用getAllResponseHeaders()看到的所有response header与实际在控制台 Network 中看到的 response header 不一样
 * 使用getResponseHeader()获取某个 header 的值时，浏览器抛错Refused to get unsafe header "XXX"
 *
 * A:
 * 1：W3C的 xhr 标准中做了限制，规定客户端无法获取 response 中的 Set-Cookie、Set-Cookie2这2个字段，无论是同域还是跨域请求；
 * 2：W3C 的 cors 标准对于跨域请求也做了限制，规定对于跨域请求，客户端允许获取的response header字段只限于“simple response header”和“Access-Control-Expose-Headers” （两个名词的解释见下方）。
 *
 * "simple response header"包括的 header 字段有：Cache-Control,Content-Language,Content-Type,Expires,Last-Modified,Pragma;
 * "Access-Control-Expose-Headers"：首先得注意是"Access-Control-Expose-Headers"进行跨域请求时响应头部中的一个字段，对于同域请求，响应头部是没有这个字段的。这个字段中列举的 header 字段就是服务器允许暴露给客户端访问的字段。
 * 所以getAllResponseHeaders()只能拿到限制以外（即被视为safe）的header字段，而不是全部字段；而调用getResponseHeader(header)方法时，header参数必须是限制以外的header字段，否则调用就会报Refused to get unsafe header的错误。
 *
 * 附：https://segmentfault.com/a/1190000004322487
 * */

// 转化配置
const transConfig = ({ action, ...rest }) => {
    const token = getToken()

    const options = {
        ...rest,
        headers: {
            ...rest.headers,
            Authorization: token,
            Source: PROJECT_CONFIG.terminalName.toLowerCase()
        }
    }

    return {
        action,
        ...options
    }
}

// 错误
function getError(action, option, xhr) {
    const msg = `fail to post ${action} ${xhr.status}'`

    const err = new Error(msg)
    err.status = xhr.status
    err.method = 'post'
    err.url = action
    err.requestId = xhr.getResponseHeader('x-oss-request-id')
    err.responseText = xhr.responseText
    return err
}

// 请求体
function getBody(xhr) {
    const text = xhr.responseText || xhr.response
    if (!text) {
        return text
    }

    try {
        return JSON.parse(text)
    } catch (e) {
        console.error('catchError', e)
        return text
    }
}

// 上传
export default function upload(config) {
    const makeRequest = option => {
        if (typeof XMLHttpRequest === 'undefined') {
            return
        }

        const xhr = new XMLHttpRequest()
        const action = option.action

        if (xhr.upload) {
            xhr.upload.onprogress = e => {
                if (e.total > 0) {
                    e.percent = (e.loaded / e.total) * 100
                }
                option.onProgress(e)
            }
        }

        const formData = new FormData()

        if (option.data) {
            Object.keys(option.data).forEach(key => {
                formData.append(key, option.data[key])
            })
        }

        formData.append(option.filename, option.file)

        xhr.onerror = () => {
            option.onError(getError(action, option, xhr), getBody(xhr))
        }

        xhr.onload = function onload() {
            if (xhr.status < 200 || xhr.status >= 300) {
                return option.onError(getError(action, option, xhr), getBody(xhr))
            }

            option.onSuccess(getBody(xhr))
        }

        xhr.open('post', action, true)

        if (option.withCredentials && 'withCredentials' in xhr) {
            xhr.withCredentials = true
        }

        const headers = option.headers || {}

        for (let item in headers) {
            if (headers.hasOwnProperty(item) && headers[item] !== null) {
                xhr.setRequestHeader(item, headers[item])
            }
        }
        xhr.send(formData)

        return xhr
    }

    let option

    if (config.ignoreToken) {
        option = config
    } else {
        option = transConfig(config)
    }

    return makeRequest(option)
}
